import {
  COOP_DEDUCTION_KEYS,
  LOAN_DEDUCTION_KEYS,
} from "../payrollReportConfig";
import {
  buildEmployeeAmountPipeline,
  buildNamedDeductionSum,
  buildPayrollAmountLookups,
} from "./shared";

const LOAN_DEDUCTION_SUM = buildNamedDeductionSum(LOAN_DEDUCTION_KEYS);
const COOP_DEDUCTION_SUM = buildNamedDeductionSum(COOP_DEDUCTION_KEYS);

export const LOAN_DEDUCTION_LOOKUPS = buildPayrollAmountLookups(
  "loanDeduction",
  "totalLoanDeduction",
  LOAN_DEDUCTION_SUM,
);

export const COOP_DEDUCTION_LOOKUPS = buildPayrollAmountLookups(
  "coopDeduction",
  "totalCoopDeduction",
  COOP_DEDUCTION_SUM,
);

export function getLoanDeductionByEmployeePipeline(employeeIds = []) {
  return buildEmployeeAmountPipeline(
    employeeIds,
    "totalLoanDeduction",
    LOAN_DEDUCTION_SUM,
  );
}

export function getCoopDeductionByEmployeePipeline(employeeIds = []) {
  return buildEmployeeAmountPipeline(
    employeeIds,
    "totalCoopDeduction",
    COOP_DEDUCTION_SUM,
  );
}
